module.exports = __webpack_public_path__ + "static/media/alicante-6.9c53a81b.jpg";